export default __webpack_public_path__ + "static/media/12_PMS_Reports_Fees Payable.175f36fa.jpg";